$(document).ready(function(){

  
  /*
    $('.mo-carousel').slick({
      infinite: true,
      swipe: true,
      TouchMove: true,
      draggable: true,
      arrows: false,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: 'linear',
      pauseOnHover: false
    });
  */
  
    $('.logo-bar').slick({
      infinite: true,
      swipe: false,
      swipeToSlide: false,
      TouchMove: false,
      draggable: false,
      arrows: false,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      LazyLoad: 'progressive',
      speed: 18000,
      slidesToShow: 4,
      slidesToScroll: 4,
      variableWidth:true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 6000,
          }
        }
      ]
    });
  
    $('.top_page').on('click', function(e){
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    })
  
    $('.sidebar a.active').on('click', function(){
      return false;
    })
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      dots: true,
      asNavFor: '.slider-nav',
      // adaptiveHeight: true
      // rows: 2
    });
  
    var setHeight = $(".grid-view-item__image-wrapper").height(); 
    $(".sidebar").height(setHeight);
  
    $('.slider-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      		autoplay: false,
		vertical: true,
		infinite: true,
		verticalSwiping: true,
	
      asNavFor: '.slider-for',
      focusOnSelect: true,
      vertical: true
    });
  
     $('.dimpou').slick({
      infinite: true,
      swipe: false,
      swipeToSlide: false,
      TouchMove: true,
      draggable: true,
      arrows: false,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      LazyLoad: 'progressive',
      speed: 18000,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth:true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 16000,
          }
        }
      ]
    });
    // $('.dimpou').slick({
    //   infinite: true,
    //   swipe: false,
    //   swipeToSlide: false,
    //   TouchMove: false,
    //   draggable: false,
    //   arrows: false,
    //   centerMode: false,
    //   autoplay: true,
    //   autoplaySpeed: 0,
    //   cssEase: 'linear',
    //   LazyLoad: 'progressive',
    //   speed: 6000,
    //   slidesToShow: 3,
    //   slidesToScroll: 1,
    // });
  
    $('#mo-product-list').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: true,
      variableWidth: false,
      outerEdgeLimit:true,
      prevArrow: '<button type="button" class="prev-btn"><img src="https://cdn.shopify.com/s/files/1/0039/7135/0574/files/chevron-left-black.svg?v=1661345737"/></button>',
      nextArrow: '<button type="button" class="next-btn"><img src="https://cdn.shopify.com/s/files/1/0039/7135/0574/files/chevron-right-black.svg?v=1661345737"/></button>',
  
      responsive: [
        {
          breakpoint: 1230,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1035,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1, 
        
            centerPadding: '80px',
             centerMode: true
          }
        }
      ]
    });
        
    $('.product-form__cart-submit').on('click', function(){
      $('.pyro').fadeIn();
      setTimeout(function(){
        $('.pyro').fadeOut();
      }, 2500)
    })
  
    
    $('.single_option_element .swatch-element').on('click', function(){
      var val = $(this).find('input').val();
      $(this).closest('.single_option_element').find('select').val(val).change();
      
    })

    
  
    $('.count_control div').on('click', function(){
      var val = $('.product-form__input--quantity').val();
      if ($(this).hasClass('icon_minus')) {
        if (val != 1) {
          val--;
          $('.product-form__input--quantity').val(val).change();
          $('.icon_count').html(val)
        }
      } else if($(this).hasClass('icon_plus')) {
        val++;
        $('.product-form__input--quantity').val(val).change();
        $('.icon_count').html(val)
      }
      console.log("changed")
      $('.mo-price-float').text('$'+ (mo_item_price * val * 0.01).toFixed(2) );
    })
  
    $('.product-form__input--quantity').change(function(){
      console.log("on change")
      $('.icon_count').html($(this).val())
    })
    $('.product-single__description h3').on('click', function(){
      $(this).toggleClass('closet');
      $(this).parent('.item').find('.content_prod').slideToggle();
    });
  
    // $('.parallax-window').paroller({ factor: 0.5, factorXs: 0.2, factorSm: 0.3, type: 'foreground', direction: 'vertical' });
  })
  
  $(document).ready(function () {
    $(window).scroll(function(){
      
      $('.parallax-window').each(function(){
        var position = $(this).position(),
        height = $(this).height();
        console.log(position.top+";");
      })
    });
  
    $('.single_faq h4').on('click', function(){
      $(this).toggleClass('active');
      $(this).closest('.single_faq').find('.unswer').slideToggle();
    })
    
    $('.sidebar-opener').on('click', function(){
      $(this).toggleClass('active');
      $(this).closest('.sidebar').find('.sidebar-filters').slideToggle();
    })
    
    $('.colec_holder label').on('click', function(){
      $(this).toggleClass('active');
      $(this).closest('.colec_holder').find('.colec').slideToggle();
      $(this).closest('.colec_holder').find('.type').slideToggle();
      $(this).closest('.colec_holder').find('.size').slideToggle();
    })
    
    /*$('.single_press').on('click', function(){
      $(this).toggleClass('active');
    })*/
    
    $(function() {
      $('.single_press').click(function() { 
        $('.single_press').not(this).removeClass('active')
        $(this).toggleClass('active')
      })
    })
  
    $('.open_size').on('click', function(e){
      e.preventDefault();
      $('.size_popup').fadeIn();
    })
  
    $('.size_popup a').on('click', function(e){
      e.preventDefault();
      $('.size_popup').fadeOut();
    })
  
    $(document).on('change', '.visible .select select', function(){
      $('.form_container:not(.visible) .select select').val($(this).val()).prop('selected', true).change();
      $(this).closest('.form_container').removeClass('visible');
      $('#form'+$(this).prop('selectedIndex')).addClass('visible');
      if ($(this).val() == "I want to sell Pals in my store.") {
     //   window.location.href = "/";
      } else if ($(this).val() == "I want to FUNdraise with Pals.") {
       // window.location.href = "/";
      }
    })
  });
  
  
  $(document).ready(function () {
    $('select').selectpicker();
  });
  
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate();
  });
  
  $(document).ready(function () {
      let headerHeight = $('#header_full').height();
      $('.body-margintop').css('padding-top', headerHeight);
    
      $(window).resize(function(e){
          let headerHeight = $('#header_full').height();
          $('.body-margintop').css('padding-top', headerHeight);
      });
  
      $('.image-with-text2').click(function() {
          var targetEL = $(this).data('href');
          window.location.href = targetEL;
      });
  
      $('.site-footer__item-inner').on('click', function() {
        $('.site-footer__item-inner').not(this).children('.site-footer__linklist').addClass('footer-hidden');
        $(this).find('.site-footer__linklist').toggleClass('footer-hidden');
        $('.site-footer__item-inner').not(this).find('.expand').addClass('plus').removeClass('minus');
        $(this).find('.expand').toggleClass('minus').toggleClass('plus');
      });
  });
  



$( document ).ready(function() {
  
      if ($(window).width() < 768) {
        $('.landing-ugc-main:not(.landing-mismatch-main) .ugc-grid').slick({
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true
          });

         $('.landing-brand-value-main .flexbox').slick({
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true
          });
        
      }

});



  // ******** bundle page ******

$(".product-single").each(function(){
$(this).find(".qty-wrap button").on('click', function(){
  var val = $(this).closest(".qty-wrap").find(".pro-qty-count").val();
   if ($(this).hasClass('qty-minus')) {
      if (val != 1) {
        val--;
        $(this).closest(".qty-wrap").find(".pro-qty-count").val(val).change();
      }
    } else if($(this).hasClass('qty-plus')) {
      val++;
      $(this).closest(".qty-wrap").find(".pro-qty-count").val(val).change();
  }
  $(this).closest(".product-single").attr("data-select-qty",val);
  // console.log("val",val);
  });
  $(this).find(".varient-wrap .custom-checkbox").each(function(){
  $(this).click(function(event){   
   event.preventDefault();
     $(this).closest(".product-info").find(".pro-qty-count").val(1);
    $(this).addClass("active").siblings().removeClass("active");
   var checkedValue = $(this).find("input").attr("data-variantID");
   var variantPrice = $(this).find("input").attr("data-variantPrice");
    // console.log("checkedValue",checkedValue);
    if (checkedValue == undefined) {
      $(this).closest(".product-single").find(".product_add").addClass("soldout_variant");
    }else{
      $(this).closest(".product-single").find(".product_add").removeClass("soldout_variant");
    }
   $(this).closest(".product-single").find(".product_add").removeClass("added");
   $(this).closest(".product-single").find(".price").html(`Add- <span>${theme.Currency.formatMoney(variantPrice, theme.moneyFormat)}</span>`);
   $(this).closest(".product-single").find(".product_add").attr("data-variant-id", checkedValue);
   $(this).closest(".product-single").find(".product_add span").text(theme.Currency.formatMoney(variantPrice, theme.moneyFormat));
   $(this).closest(".product-single").find(".product_add").attr("data-selected-price",variantPrice);
    
  });
  });
  $(this).find(".product_add").click(function(event){
    event.preventDefault();
    $(this).addClass("added");
    $(this).find(".price").text("","");
    var getCurrentID = $(this).attr("data-variant-id");
    var attr = $(this).closest(".product-single").attr('data-select-qty');
    $(this).closest(".product-single").attr("data-selected-ID",getCurrentID);
    if (typeof attr !== 'undefined' && attr !== false) {
    }else{
      $(this).closest(".product-single").attr("data-select-qty","1");
    }
    var getItemImg = $(this).closest(".product-single").find(".product-image img").attr("src");
    var getItemTitle = $(this).closest(".product-single").find(".product-title").html();
    var getItemQty = $(this).closest(".product-single").attr("data-select-qty");
    // console.log("getItemQty",getItemQty);
    var getItemPrice = $(this).attr("data-selected-price");

    var itmetotal = getItemQty * getItemPrice;
    // console.log("itmetotal",itmetotal);
    var proudctAddHTML = `<div class="product-block" data-selected-ID="${getCurrentID}" data-select-qty="${getItemQty}" data-select-price="${itmetotal}" data-item-price="${getItemPrice}">
                        <div class="product-block-wrap">
                          <div class="product-image">
                            <div class="image-wrap">
                              <img src="${getItemImg}" alt="product-image">
                            </div>
                          </div>
                          <div class="product-info">
                            <div class="info-wrap">
                              
                              <div class="star-rating-wrap">
                                <img src="https://cdn.shopify.com/s/files/1/0039/7135/0574/files/landing-black-star-icon.png?v=1692796390" alt="star-icon">
                              </div>
                              
                              <div class="title-price-wrap">
                                <div class="product-title-wrap">
                                  ${getItemTitle}
                                </div>
                                <div class="product-price-wrap">
                                  <div class="price">${theme.Currency.formatMoney(getItemPrice, theme.moneyFormat)}</div>
                                </div>
                              </div>
                        
                              <div class="qty-btn-wrap">
                                <div class="qty-block">
                                  <div class="qty-wrap">
                                  <button type="button" class="qty-minus">-</button>
                                  <input class="pro-qty-count" type="text" name="pro-qty" value="${getItemQty}" min="1">
                                  <button type="button" class="qty-plus">+</button>
                                  </div>
                                </div>  
                                <div class="remove-block">
                                  <div class="btn-remove"><img src="https://cdn.shopify.com/s/files/1/0039/7135/0574/files/landing-remove-icon.png?v=1692858078" alt="remove-icon">Remove</div>
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                        </div>`;
    
      // console.log(".proudctAddHTML",proudctAddHTML);

    $(".product-block").each(function(){
    var blockID = $(this).attr("data-selected-id");
     if (getCurrentID == blockID) {
       $(this).remove();
     }else{
     }
    }); 
    if ( $(window).width() < 767 ) {
      // console.log("mobile");
      $(".bundle-result-mobile").find(".added-product-list").prepend(proudctAddHTML);
    } else{
      // console.log("desktop");
      $(".bundle-column").find(".added-product-list").prepend(proudctAddHTML);
    }
   
    
    setTimeout(function(){
    $(".product-block").each(function(){
    var getblockPrice = $(this).attr("data-item-price");
    $(this).find(".qty-wrap button").unbind().click(function(event){
      event.preventDefault();
      var val = $(this).closest(".qty-wrap").find(".pro-qty-count").val();
       if ($(this).hasClass('qty-minus')) {
          if (val != 1) {
            val--;
            $(this).closest(".qty-wrap").find(".pro-qty-count").val(val).change();
           
          }
        } else if($(this).hasClass('qty-plus')) {
          val++;
          $(this).closest(".qty-wrap").find(".pro-qty-count").val(val).change();
      }
      $(this).closest(".product-block").attr("data-select-qty",val);
       // console.log("val",val);
       var newblockPrice = val * getblockPrice;
       // console.log("newblockPrice",newblockPrice);
      $(this).closest(".product-block").attr("data-select-price",newblockPrice);
      });
      $(this).find(".remove-block").on('click', function(){
        $(this).closest(".product-block").remove();
       var removeID = $(this).closest(".product-block").attr("data-selected-id");
      var remove_price = $(this).closest(".product-block").attr("data-select-price");
        
        $(".product-single").each(function(){
          var signle_id = $(this).attr("data-selected-id");
          if (removeID == signle_id) {
            $(this).find(".product_add").removeClass("added");
            $(this).find(".product_add .price").html(`Add- <span>${theme.Currency.formatMoney(remove_price, theme.moneyFormat)}</span>`);
          }
        });
      }); 
    });
    },1000);
   setInterval(function(){
    var getProductCount = $(".added-product-list").find(".product-block").length;
     if (getProductCount >0 ) {
      $(".result_products").find(".atc-main-btn").css("display","block"); 
     }
    $(".total-qty-count-block").find("el").text(getProductCount);
      var finalPrice = [];
     var finalQty = [];
      $(".product-block").each(function(){
         finalPrice.push($(this).attr("data-select-price"));
        finalQty.push($(this).attr("data-select-qty"));
      }); 
       var total = 0;

      for (var i = 0; i < finalPrice.length; i++) {
          total += finalPrice[i] << 0;
      }
     var Qtytotal = 0;
      for (var i = 0; i < finalQty.length; i++) {
          Qtytotal += finalQty[i] << 0;
      }
     // console.log("Qtytotal",Qtytotal);
      $(".total-qty-count-block").find("el").text(Qtytotal);
     if (getProductCount >=5 || Qtytotal >=5 ) {
       if(getProductCount >=7 || Qtytotal >=7){
         $('.total-qty-count-block .dicount_label').text('15 % off');
         var dicount_price = ((total * 15) / 100);
         var new_dicount_price = (total - dicount_price);
       }else{
        $('.total-qty-count-block .dicount_label').text('10 % off');
        var dicount_price = ((total * 10) / 100);
         var new_dicount_price = (total - dicount_price);
       }
      $(".discount_price").text(theme.Currency.formatMoney(new_dicount_price, theme.moneyFormat));
      $(".discount_price").css("opacity","1"); 
      $(".dicount_label").css("display","block"); 
       $(".total-price-block").find(".price").addClass("apply_discount"); 
       // console.log("dicount_price",new_dicount_price);
     }else{
       $('.total-qty-count-block .dicount_label').hide();
       $(".discount_price").css("opacity","0"); 
       $(".dicount_label").css("display","none"); 
       $(".total-price-block").find(".price").removeClass("apply_discount"); 
     }
      $(".total-price-block").find(".price").text(theme.Currency.formatMoney(total, theme.moneyFormat))
    },1000);
    
  });
});

  $(".bundle-result-mobile .result-wrap").click(function(){
    $(".result_products").slideToggle();
    $(this).toggleClass("active");
  });

$(document).ready(function(){
  $('.atc-main-btn button').click(function(){
    var finalData = { items: []};
    $(".added-product-list .product-block").each(function(){
      if ($(this).attr('data-select-qty') > 0 && $(this).attr('data-selected-id') > 0){
      var getVarintID = $(this).attr("data-selected-id");
      var getVarintQty = $(this).attr("data-select-qty");
      finalData.items.push({
        'id':getVarintID,
        'quantity':getVarintQty
      });
      }
    });
    fetch('/cart/clear.js',)
    .then(response => response.json()).then(response => {
       addItemToCart(finalData);
      });
   
  });
});
function addItemToCart(finalData) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: finalData,
    dataType: 'json',
    success: function(data) {
      // console.log("data",data);
      document.location.href = '/cart/checkout';
      
    }
  }); 
}

$(document).ready(function () {
    size_single = $(".product-grid .product-single").size();
    show_count=6;
    $('.product-grid .product-single:lt('+show_count+')').show();
    $(".bundle-grid").find('.bundle_load_more').click(function () {
    show_count= (show_count+6 <= size_single) ? show_count+6 : size_single;
    $('.product-grid .product-single:lt('+show_count+')').show();
    if (size_single == show_count) {
      $(this).hide();
    }else{
    }
    });
    // $('#showLess').click(function () {
    //     show_count=(show_count-6<0) ? 6 : show_count-6;
    //     $('.product-grid .product-single').not(':lt('+show_count+')').hide();
    // });

  $(".landing-mismatch-main .mismatch_load_more").hide();
    if ( $(window).width() < 767 ) {
       $(".landing-mismatch-main .mismatch_load_more").show();
      $(".landing-mismatch-main .ugc-col").hide();
    size_col = $(".landing-mismatch-main .ugc-col").size();
      show_image=3;
      $('.landing-mismatch-main .ugc-col:lt('+show_image+')').show();
     $(".landing-mismatch-main").find('.mismatch_load_more').click(function () {
          show_image= (show_image+3 <= size_col) ? show_image+3 : size_col;
          $('.landing-mismatch-main .ugc-col:lt('+show_image+')').show();
        if (size_col == show_image) {
          $(this).hide();
        }else{
        }
      });
    }
});

// const video = document.getElementById("video");
// const circlePlayButton = document.getElementById("circle-play-b");

// function togglePlay() {
// 	if (video.paused || video.ended) {
// 		video.play();
// 	} else {
// 		video.pause();
// 	}
// }

// circlePlayButton.addEventListener("click", togglePlay);
// video.addEventListener("playing", function () {
// 	circlePlayButton.style.opacity = 0;
// });
// video.addEventListener("pause", function () {
// 	circlePlayButton.style.opacity = 1;
// });

// $(".ugc-col").each(function(){
//   $(this).find(".play-pause-btn").click(function(){
//     //  if($(this).attr('data-click-state') == 1) {
//     //     $(this).attr('data-click-state', 0);
//     //     $(this).css('background-color', 'red')
//     //   }
//     // else {
//     //   $(this).attr('data-click-state', 1);
//     //   $(this).css('background-color', 'orange')
//     // }
//      $(this).closest(".ugc-col").find('video').trigger('play')
//       $(this).closest(".ugc-col").siblings().find('video').trigger('pause');
//       $(this).css("opacity",0);
//       $(this).closest(".ugc-col").siblings().find(".play-pause-btn").css("opacity",1);
//   });
// });
  